// Tiny fetch wrapper for the blog API
const API = process.env.REACT_APP_BACKEND_URL;

const handle = async (res) => {
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(`Request failed (${res.status}): ${detail || res.statusText}`);
  }
  return res.json();
};

export const fetchBlogTags = async () => {
  const res = await fetch(`${API}/api/blog/tags`);
  return handle(res);
};

export const fetchBlogPosts = async ({ tag, q, page = 1, limit = 12, signal } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (tag && tag !== 'All') params.set('tag', tag);
  if (q) params.set('q', q);
  const res = await fetch(`${API}/api/blog/posts?${params.toString()}`, { signal });
  return handle(res);
};

export const fetchFeaturedPosts = async (limit = 3) => {
  const res = await fetch(`${API}/api/blog/featured?limit=${limit}`);
  return handle(res);
};

export const fetchBlogPost = async (id, { signal } = {}) => {
  const res = await fetch(`${API}/api/blog/posts/${encodeURIComponent(id)}`, { signal });
  if (res.status === 404) return null;
  return handle(res);
};
